import { Injectable } from '@angular/core';
import { setVisitor } from '@fund-base/store/actions/auth.actions';
import { setVisitorLimits, setVisitorStartDate } from '@fund-base/store/actions/visitors.action';
import { selectVisitorsState } from '@fund-base/store/selectors/visitors.selectors';
import {
  getVisitorLastAILetterDate,
  getVisitorLastSearchDate,
  setVisitorLastAILetterDate,
  setVisitorLastSearchDate,
} from '@fund-base/utils/helpers/visitors/visitors.helpers';
import { Store } from '@ngrx/store';
import { take } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class StorageService {
  [x: string]: any;
  setItem(key: string, value: any) {
    try {
      if (!!key) {
        if (!!value) {
          localStorage.setItem(key, JSON.stringify(value));
        } else {
          localStorage.removeItem(key);
        }
      }
    } catch (e) {
      console.error('Cannot stringify value for storage');
    }
  }

  getItem<T>(key: string): T | undefined {
    if (!!key && !!localStorage?.getItem(key)) {
      return JSON?.parse(<string>localStorage?.getItem(key));
    }
    return undefined;
  }

  clearStorage(store: Store) {
    store
      .select(selectVisitorsState)
      .pipe(take(1))
      .subscribe(state => {
        const lastSearchDate = getVisitorLastSearchDate();
        const lastAiLetterDate = getVisitorLastAILetterDate();
        // IMPORTANT: preserve the app version across logout.
        // `AppComponent.invalidateCache()` clears storage if `version` is missing/mismatched.
        // If we delete `version` on logout and the user logs back in without a full refresh,
        // opening the app in a new tab can trigger invalidation and wipe auth (`token`/`user`).
        const appVersion = localStorage.getItem('version');

        localStorage.clear();

        if (appVersion) {
          localStorage.setItem('version', appVersion);
        }

        // Keep only the visitor limits and start date
        if (lastSearchDate) {
          setVisitorLastSearchDate(lastSearchDate);
        }

        if (lastAiLetterDate) {
          setVisitorLastAILetterDate(lastAiLetterDate);
        }

        store.dispatch(setVisitorLimits({ limits: state.limits }));
        if (state.startDate) {
          store.dispatch(setVisitorStartDate({ startDate: state.startDate }));
        }
      });
  }

  clearAllStorage() {
    localStorage.clear();
    sessionStorage.clear();
    this.clearCookies();
  }

  clearCookies() {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
      document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    }
  }
}
